var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { DownCaretIcon } from '../Icon';
/**
 * Kareo wrapped component of the Material-UI AccordionSummary. The prop API has been limited to props defined in AccordionSummaryProps.
 *
 * Material-UI AccordionSummary: [Docs](https://v4.mui.com/components/accordion/), [API](https://v4.mui.com/api/accordion-summary/)
 *
 * @storybook: [Accordion](http://design.kareoprod.ent/design-system/?path=/story/components-surfaces-accordion--simple-and-disabled-accordion)
 */
var AccordionSummary = React.forwardRef(function (props, ref) { return (React.createElement(MuiAccordionSummary, __assign({}, props, { ref: ref, expandIcon: React.createElement(DownCaretIcon, { fontSize: "small", color: "disabled" }) }))); });
AccordionSummary.displayName = 'KareoAccordionSummary';
export default AccordionSummary;
